import type { FaireProductEntity } from "../../entity_types/product";

export const p_u6ywghffnx: FaireProductEntity = {
  token: "p_u6ywghffnx",
  type: "product",
  name: "Honey Box Set (Duo)",
  brandName: "Kailua Honey Lifestyle",
  imageUrl:
    "https://cdn.faire.com/fastly/6d9126ed0f13fdf5d3d412c9b3ccad952e5a382aff9fbf1807539f75ee01b90b.jpeg",
  priceDollars: 8.98,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/c7b3952833687a68144dcc8085fc732b0ec85692df1107d8e85c234e9633cd22.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
